import {ReadyProvider} from '../../../application/providers/readyProvider';
import {VoteLike} from '../../../application/vote/voteLike';
import {Form} from '../../../application/forms/form';

ReadyProvider.executeOnReady(() => {
    new VoteLike(document.querySelector('[data-article="vote"]'));
    new Form(document.querySelector('[data-comment="form"]'));
});
